export const createPayloadForMdw = (activeStep, formData) => {
    switch (activeStep) {
        case 3:
            return constructPayloadStep3(formData)
        case 4:
            return constructPayloadStep4(formData)
        case 6:
            return constructPayloadStep6(formData)
    }
}

export const constructPayloadStep3 = formData => {
    return {
        idCardNumber: formData.idCardNumber,
        idCardEmissionDate: formData.idCardEmissionDate,
        idCardExpirationDate: formData.idCardExpirationDate,
        birthDate: formData.birthDate,
        nameOnIdCard: formData.nameOnIdCard,
        fatherName: formData.fatherName,
        motherName: formData.motherName,
        maritalStatus: formData.maritalStatus,
        birthLocationProvince: formData.birthLocationProvince,
        gender: formData.gender,
        address: formData.address
    }
}

export const constructPayloadStep4 = formData => {
    let customerCreationProcessProfessionalInformationView = {
        occupationalStatus: {
            id: formData.occupationalStatus
        },
        profession: formData.profession,
        companyFunction: formData.companyFunction,
        jobDescription: formData.jobDescription,
        monthlyIncome: formData.monthlyIncome,
        monthlyExpenses: formData.monthlyExpenses,
        corporateInterests: formData.corporateInterests === 'Yes'
    }

    if (formData.occupationalStatus === 3) {
        customerCreationProcessProfessionalInformationView = {
            ...customerCreationProcessProfessionalInformationView,
            nifEmployerEntity: formData.nifEmployerEntity,
            employerEntity: formData.employerEntity,
            admissionDate: formData.admissionDate,
            companyAddress: formData.companyAddress,
            companyDoorNumber: formData.companyDoorNumber,
            companyFloorNumber: formData.companyFloorNumber,
            companyCountry: formData.companyCountry,
            companyProvince: formData.companyProvince,
            companyCounty: formData.companyCounty,
            companyZipCode: formData.companyZipCode,
            contractualBond: formData.contractualBond
        }
    }

    if (formData.corporateInterests === 'Yes') {
        customerCreationProcessProfessionalInformationView = {
            ...customerCreationProcessProfessionalInformationView,
            shareHoldingsList: formData.shareHoldingsList
        }
    }

    return {
        email: formData.email,
        customerCreationProcessPersonalInformationView: {
            numberOfChildren: formData.numberOfChildren,
            houseHold: formData.houseHold,
            literaryAbilities: formData.literaryAbilities
        },
        customerCreationProcessProfessionalInformationView: customerCreationProcessProfessionalInformationView,
        customerCreationProcessPPEInformationView: {
            politicalExposed: formData.isPoliticalExposed === 'Yes', // Removed "is" before politicalExposed due to how MDW has it's getter setup
            politicalPosition: formData.isPoliticalExposed === 'Yes' ? formData.politicalPosition : null,
            hasFamilyPoliticalExposed: formData.hasFamilyPoliticalExposed === 'Yes',
            politicalFamilyName: formData.hasFamilyPoliticalExposed === 'Yes' ? formData.politicalFamilyName : null,
            politicalDegreeOfKinship: formData.hasFamilyPoliticalExposed === 'Yes' ? formData.politicalDegreeOfKinship : null,
            hasCommercialRelationhipWithPoliticalExposed: formData.hasCommercialRelationhipWithPoliticalExposed === 'Yes',
            nameOfPoliticalExposed: formData.hasCommercialRelationhipWithPoliticalExposed === 'Yes' ? formData.nameOfPoliticalExposed : null
        },
        customerCreationProcessFATCAInformationView: {
            hasLivedInTheUS: formData.hasLivedInTheUS === 'Yes',
            hasAmericanPassport: formData.hasAmericanPassport === 'Yes',
            hasTaxObligationInTheUS: formData.hasTaxObligationInTheUS === 'Yes',
            hasTin: formData.hasTin === 'Yes',
            tin: formData.hasTin === 'Yes' ? formData.tin : null
        }
    }
}

export const constructPayloadStep6 = formData => {
    return {
        branch: {
            id: formData.branchId
        }
    }
}

export const updateFormDataWithPreSavedIndo = (savedInMdwInfo, lastSavedStep) => {
    let tempObj = {}
    /* Document Images Data */
    if (lastSavedStep >= 2) {
        tempObj = {
            ...tempObj,
            frontFile: 'front',
            backFile: 'back'
        }
    }
    /* We have document info */
    if (lastSavedStep >= 3) {
        tempObj = {
            ...tempObj,
            /* Identification Data */
            idCardNumber: savedInMdwInfo.idCardNumber,
            idCardEmissionDate: savedInMdwInfo.idCardEmissionDate,
            idCardExpirationDate: savedInMdwInfo.idCardExpirationDate,
            birthDate: savedInMdwInfo.birthDate,
            /* Personal Data */
            nameOnIdCard: savedInMdwInfo.name,
            fatherName: savedInMdwInfo.fatherName,
            motherName: savedInMdwInfo.motherName,
            maritalStatus: savedInMdwInfo.maritalStatus,
            birthLocationProvince: savedInMdwInfo.birthLocationProvince,
            gender: savedInMdwInfo.gender,
            address: savedInMdwInfo.address
        }
    }
    /* We have step4 info */
    if (lastSavedStep >= 4) {
        tempObj = {
            ...tempObj,
            email: savedInMdwInfo.email || '-', /* non mandatory field */
            /* Step 4 General Info */
            generalInfo: savedInMdwInfo.customerCreationProcessProfessionalInformationView ? true : null,
            numberOfChildren: createFormValue(savedInMdwInfo.customerCreationProcessPersonalInformationView?.numberOfChildren),
            houseHold: savedInMdwInfo.customerCreationProcessPersonalInformationView?.houseHold || '',
            literaryAbilities: savedInMdwInfo.customerCreationProcessPersonalInformationView?.literaryAbilities || '',
            occupationalStatus: savedInMdwInfo.customerCreationProcessProfessionalInformationView?.occupationalStatus.id || '',
            nifEmployerEntity: savedInMdwInfo.customerCreationProcessProfessionalInformationView?.nifEmployerEntity || '',
            employerEntity: savedInMdwInfo.customerCreationProcessProfessionalInformationView?.employerEntity || '',
            admissionDate: savedInMdwInfo.customerCreationProcessProfessionalInformationView?.admissionDate || '',
            companyAddress: savedInMdwInfo.customerCreationProcessProfessionalInformationView?.companyAddress || '',
            companyDoorNumber: savedInMdwInfo.customerCreationProcessProfessionalInformationView?.companyDoorNumber || '',
            companyFloorNumber: savedInMdwInfo.customerCreationProcessProfessionalInformationView?.companyFloorNumber || '',
            companyCountry: savedInMdwInfo.customerCreationProcessProfessionalInformationView?.companyCountry || '',
            companyProvince: savedInMdwInfo.customerCreationProcessProfessionalInformationView?.companyProvince || '',
            companyCounty: savedInMdwInfo.customerCreationProcessProfessionalInformationView?.companyCounty || '',
            companyZipCode: savedInMdwInfo.customerCreationProcessProfessionalInformationView?.companyZipCode || '',
            occupationalStatusProof: savedInMdwInfo.customerCreationProcessProfessionalInformationView ? { file: '', name: 'comprovativo' } : null,
            profession: savedInMdwInfo.customerCreationProcessProfessionalInformationView?.profession || '',
            contractualBond: savedInMdwInfo.customerCreationProcessProfessionalInformationView?.contractualBond || '',
            companyFunction: savedInMdwInfo.customerCreationProcessProfessionalInformationView?.companyFunction || '',
            jobDescription: savedInMdwInfo.customerCreationProcessProfessionalInformationView?.jobDescription || '',
            monthlyIncome: savedInMdwInfo.customerCreationProcessProfessionalInformationView?.monthlyIncome || '',
            monthlyExpenses: savedInMdwInfo.customerCreationProcessProfessionalInformationView?.monthlyExpenses || '',
            corporateInterests: createFormValue(savedInMdwInfo.customerCreationProcessProfessionalInformationView?.corporateInterests) || '',
            shareHoldingsList: savedInMdwInfo.customerCreationProcessProfessionalInformationView?.shareHoldingsList || '',
            /* Step 4 PPE */
            ppe: savedInMdwInfo.customerCreationProcessPPEInformationView ? true : null,
            isPoliticalExposed: createFormValue(savedInMdwInfo.customerCreationProcessPPEInformationView?.politicalExposed),
            politicalPosition: savedInMdwInfo.customerCreationProcessPPEInformationView?.politicalExposed ? savedInMdwInfo.customerCreationProcessPPEInformationView.politicalPosition : '',
            hasFamilyPoliticalExposed: createFormValue(savedInMdwInfo.customerCreationProcessPPEInformationView?.hasFamilyPoliticalExposed),
            politicalFamilyName: savedInMdwInfo.customerCreationProcessPPEInformationView?.hasFamilyPoliticalExposed ? savedInMdwInfo.customerCreationProcessPPEInformationView.politicalFamilyName : '',
            politicalDegreeOfKinship: savedInMdwInfo.customerCreationProcessPPEInformationView?.hasFamilyPoliticalExposed ? savedInMdwInfo.customerCreationProcessPPEInformationView.politicalDegreeOfKinship : '',
            hasCommercialRelationhipWithPoliticalExposed: createFormValue(savedInMdwInfo.customerCreationProcessPPEInformationView?.hasCommercialRelationhipWithPoliticalExposed),
            nameOfPoliticalExposed: savedInMdwInfo.customerCreationProcessPPEInformationView?.hasCommercialRelationhipWithPoliticalExposed ? savedInMdwInfo.customerCreationProcessPPEInformationView.nameOfPoliticalExposed : '',
            /* Step 4 FATCA */
            fatca: savedInMdwInfo.customerCreationProcessFATCAInformationView ? true : null,
            fatcaForm: savedInMdwInfo.customerCreationProcessFATCAInformationView?.fatcaForm || '',
            hasLivedInTheUS: createFormValue(savedInMdwInfo.customerCreationProcessFATCAInformationView?.hasLivedInTheUS),
            hasAmericanPassport: createFormValue(savedInMdwInfo.customerCreationProcessFATCAInformationView?.hasAmericanPassport),
            hasTaxObligationInTheUS: createFormValue(savedInMdwInfo.customerCreationProcessFATCAInformationView?.hasTaxObligationInTheUS),
            hasTin: createFormValue(savedInMdwInfo.customerCreationProcessFATCAInformationView?.hasTin),
            tin: savedInMdwInfo.customerCreationProcessFATCAInformationView?.hasTin ? savedInMdwInfo.customerCreationProcessFATCAInformationView.tin : ''
        }
    }

    /* Video Step 5 */
    if (lastSavedStep >= 5) {
        tempObj = {
            ...tempObj,
            interviewVideo: 'file exists'
        }
    }

    /* Branch Step 6 */
    if (lastSavedStep >= 6) {
        tempObj = {
            ...tempObj,
            branchId: savedInMdwInfo.branch.id
        }
    }

    return tempObj
}

export const createFormValue = value => {
    if (value || value === false) return value ? (typeof value === 'boolean' ? 'Yes' : value) : 'No'
    if (value === 0) return value.toString()
    return ''
}
